import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  IStatusDatesValue,
  StatusDateForm,
} from 'src/app/shared/interfaces/provider/provider-group.interfaces';
import { DatepickerService } from 'src/app/shared/services/datepicker.service';

@Component({
  selector:
    '[formGroup] section-status-dates, [formGroupName] section-status-dates',
  templateUrl: './status-dates.component.html',
})
export class StatusDatesComponent implements OnInit, OnDestroy {
  @Input() isEditMode = false;

  formStatusDates: FormGroup<StatusDateForm>;

  private _formStatusDatesValue: IStatusDatesValue = {};
  private _isCheckboxChecked = false;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private controlContainer: ControlContainer,
    private datepickerService: DatepickerService,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.formStatusDates = this.controlContainer
      .control as FormGroup<StatusDateForm>;

    this.subscriptions.add(
      this.formStatusDates.valueChanges.subscribe(() => {
        this._formStatusDatesValue = this._isCheckboxChecked
          ? this._formStatusDatesValue
          : { ...this.formStatusDates.getRawValue() };
      }),
    );
  }

  onStatusChange(dateControlName: string) {
    this._isCheckboxChecked = true;

    const dateValue = this.datepickerService.toISOStringInUTC(new Date());

    this.formStatusDates.patchValue({
      [dateControlName]: dateValue,
    });
  }
}
